/* Generated from Java with JSweet 2.3.7 - http://www.jsweet.org */
import { DocumentType } from '../models/DocumentType';

/**
 * Constructor.
 * @param {string} code
 * @param {string} name
 * @param {string} type
 * @param {string} entity
 * @param {Array} versions
 * @param {boolean} specMandated
 * @param {string} messageTemplate
 * @param {*} ruleClass
 * @class
 * @author eric.wittmann@gmail.com
 */
export class ValidationRuleMetaData {
    public code : string;

    public name : string;

    public type : string;

    public entity : string;

    public versions : DocumentType[];

    public specMandated : boolean;

    public messageTemplate : string;

    public ruleClass : any;

    public constructor(code? : any, name? : any, type? : any, entity? : any, versions? : any, specMandated? : any, messageTemplate? : any, ruleClass? : any) {
        if(((typeof code === 'string') || code === null) && ((typeof name === 'string') || name === null) && ((typeof type === 'string') || type === null) && ((typeof entity === 'string') || entity === null) && ((versions != null && versions instanceof <any>Array && (versions.length==0 || versions[0] == null ||(typeof versions[0] === 'number'))) || versions === null) && ((typeof specMandated === 'boolean') || specMandated === null) && ((typeof messageTemplate === 'string') || messageTemplate === null) && ((ruleClass != null) || ruleClass === null)) {
            let __args = arguments;
            if(this.code===undefined) this.code = null;
            if(this.name===undefined) this.name = null;
            if(this.type===undefined) this.type = null;
            if(this.entity===undefined) this.entity = null;
            if(this.versions===undefined) this.versions = null;
            if(this.specMandated===undefined) this.specMandated = false;
            if(this.messageTemplate===undefined) this.messageTemplate = null;
            if(this.ruleClass===undefined) this.ruleClass = null;
            if(this.code===undefined) this.code = null;
            if(this.name===undefined) this.name = null;
            if(this.type===undefined) this.type = null;
            if(this.entity===undefined) this.entity = null;
            if(this.versions===undefined) this.versions = null;
            if(this.specMandated===undefined) this.specMandated = false;
            if(this.messageTemplate===undefined) this.messageTemplate = null;
            if(this.ruleClass===undefined) this.ruleClass = null;
            (() => {
                this.code = code;
                this.name = name;
                this.type = type;
                this.entity = entity;
                this.versions = versions;
                this.specMandated = specMandated;
                this.messageTemplate = messageTemplate;
                this.ruleClass = ruleClass;
            })();
        } else if(code === undefined && name === undefined && type === undefined && entity === undefined && versions === undefined && specMandated === undefined && messageTemplate === undefined && ruleClass === undefined) {
            let __args = arguments;
            if(this.code===undefined) this.code = null;
            if(this.name===undefined) this.name = null;
            if(this.type===undefined) this.type = null;
            if(this.entity===undefined) this.entity = null;
            if(this.versions===undefined) this.versions = null;
            if(this.specMandated===undefined) this.specMandated = false;
            if(this.messageTemplate===undefined) this.messageTemplate = null;
            if(this.ruleClass===undefined) this.ruleClass = null;
            if(this.code===undefined) this.code = null;
            if(this.name===undefined) this.name = null;
            if(this.type===undefined) this.type = null;
            if(this.entity===undefined) this.entity = null;
            if(this.versions===undefined) this.versions = null;
            if(this.specMandated===undefined) this.specMandated = false;
            if(this.messageTemplate===undefined) this.messageTemplate = null;
            if(this.ruleClass===undefined) this.ruleClass = null;
        } else throw new Error('invalid overload');
    }

    /**
     * Returns true if this rule applies to documents of the given type.
     * @param {DocumentType} type
     * @return {boolean}
     */
    public appliesTo(type : DocumentType) : boolean {
        for(let index159=0; index159 < this.versions.length; index159++) {
            let version = this.versions[index159];
            {
                if(type === version) {
                    return true;
                }
            }
        }
        return false;
    }
}
ValidationRuleMetaData["__class"] = "io.apicurio.datamodels.core.validation.ValidationRuleMetaData";



